import { useMemo } from 'react';
import { useAreas } from './useAreas';

export function useFloors(
  officeId: string | null,
  parentId: string | null = null
) {
  const { areas, refetch, loading } = useAreas(officeId, parentId);
  const floors = useMemo(
    () =>
      areas?.elements
        ? areas.elements
            .filter((x) => x.is_available)
            .sort((a, b) => (a.weight ?? 0) - (b.weight ?? 0))
        : undefined,
    [areas]
  );
  return { floors, refetch, loading };
}
